import { get as _get } from 'lodash';

import { AppConfigKey, AppConfigMap } from './appConfigMap';
import { getArgoConfig } from '@awsscm/argo-core/argo/window';

/**
 * Get configuration value by using current stage, and a configuration key.
 * 
 * @param configKey - configuration key
 * @returns - configuration value
 */
export function getConfigValue(configKey: AppConfigKey) {
  const config = getArgoConfig();
  const stage = _get(config, 'argo.frameworkStage', '');
  const cell = _get(config, 'argo.cell', '');

  if (stage === '' || cell === '') {
    return null;
  }

  const configStageKey = stage + '.' + cell;

  return _get(AppConfigMap, [configStageKey, configKey], null);
}